module.exports = __webpack_public_path__ + "img/new-files-not-found.f5295d87.svg";